const stripTaller = (name = "") => name.replace(/^\s*taller\s+/i, "").trim();

export const giftLink = (token) => `${window.location.origin}/regalo/${token}`;

export function giftWhatsAppUrl(r) {
  const g = r.gift || {};
  const giver = g.giver_name || r.customer_name || "alguien especial";
  const text = `${g.recipient_name}, has recibido un hermoso regalo de ${giver}. El taller ${stripTaller(r.workshop_name)} es para ti. `
    + `El mensaje dice: "${g.message || ""}" \u{1F381}\n${giftLink(g.token)}`;
  return `https://wa.me/${(g.recipient_phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;
}

export const countWords = (s = "") => s.trim().split(/\s+/).filter(Boolean).length;

export function thanksWhatsAppUrl({ giver_name, giver_phone, workshop_name }) {
  const text = `¡Gracias, ${giver_name}! Recibí tu regalo, el taller ${stripTaller(workshop_name)}. \u{1F49C}`;
  return `https://wa.me/${(giver_phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;
}
